// Libs
import React, { Component } from 'react'
import _map from 'lodash/map'

// Image
import gridCenterIcon from '../icons/grid-center.url.svg'

// Components
import { Polyline, LayerGroup, Marker } from 'react-leaflet'
import L from 'leaflet'

// Styles
const styles = {
  grid: {
    color: '#FF0000',
    strokeWidth: 0.5,
  },
}

// Props
type Props = {
  gridData: Object
}

// Local
const gridCenter = L.icon({
  iconUrl: gridCenterIcon,
  iconSize: [7, 7],
})

// Exports
class ExistingGrid extends Component {
  props: Props

  renderGrid ({ shapes }): React.Element<any> {
    return _map(shapes, ({positions, center, strokeWidth, strokeColor}) =>
      <Polyline
        key={`marker_${center[0]}_${center[1]}`}
        positions={positions}
        color={styles.grid.color}
        weight={styles.grid.strokeWidth} />
    )
  }

  renderPoints ({ gridPoints, squareGrid }): React.Element<any> {
    return _map(gridPoints, (gridPoint, i) => {
      if (gridPoint) {
        return (
          <Marker
            position={gridPoint}
            icon={gridCenter}
            key={`marker-${i}`}
          />
        )
      }
    })
  }

  renderGrids (): React.Element<any> {
    return _map(this.props.gridData, (grid, i) => <LayerGroup key={`layer-group-${i}`}>
      {this.renderGrid(grid)}
      {this.renderPoints(grid)}
    </LayerGroup>)
  }


  render (): React.Element<any> {
    return (
      <div data-test='hefty-grid'>
        {this.props.gridData ? this.renderGrids() : null}
      </div>
    )
  }
}

export default ExistingGrid
